import { render, staticRenderFns } from "./TOProposalOverview.vue?vue&type=template&id=0eb6616c"
import script from "./TOProposalOverview.vue?vue&type=script&lang=js"
export * from "./TOProposalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports